import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

// My Files
import ToolbarWithLogo from "../ToolbarWithLogo";
import { UserContext } from "../../context";
import firebase from "../../firebase";
import UserFeed from "./UserFeed";

export default function HomePage() {
    const history = useHistory();

    const { currentUserData } = useContext(UserContext);

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
            // detaching the listener
            if (!user) {
                // If no user is logged in, redirect to sign in page
                history.replace("/signin");
            }
        });

        return () => unsubscribe();
    }, [currentUserData, history]);

    return (
        <Box
            sx={{
                minHeight: "calc(100vh - 64px)",
                backgroundColor: "background.default",
                pt: { xs: 2, sm: 3, md: 4 },
            }}
        >
            <Container
                maxWidth="md"
                sx={{
                    px: { xs: 1.5, sm: 3 },
                }}
            >
                <UserFeed />
            </Container>
            <ToolbarWithLogo />
        </Box>
    );
}
